import React, { useState } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { FormatterView } from './tools/FormatterView';
import { MinifierView } from './tools/MinifierView';
import { DiffView } from './tools/DiffView';
import { TypeGeneratorView } from './tools/TypeGeneratorView';
import { JqQueryView } from './tools/JqQueryView';
import { SchemaValidatorView } from './tools/SchemaValidatorView';
import { JsonCsvView } from './tools/JsonCsvView';
import { JsonYamlView } from './tools/JsonYamlView';
import './Layout.css';

export type ToolTab = 'formatter' | 'minifier' | 'diff' | 'types' | 'query' | 'schema' | 'csv' | 'yaml';

export const Layout: React.FC = () => {
  const [activeTab, setActiveTab] = useState<ToolTab>('formatter');

  const renderActiveView = () => {
    switch (activeTab) {
      case 'formatter': return <FormatterView />;
      case 'minifier': return <MinifierView />;
      case 'diff': return <DiffView />;
      case 'types': return <TypeGeneratorView />;
      case 'query': return <JqQueryView />;
      case 'schema': return <SchemaValidatorView />;
      case 'csv': return <JsonCsvView />;
      case 'yaml': return <JsonYamlView />;
      default: return <FormatterView />;
    }
  };

  return (
    <div className="layout-container">
      <Header activeTab={activeTab} onTabChange={setActiveTab} />
      <main className="layout-main">
        {renderActiveView()}
      </main>
      <Footer />
    </div>
  );
};
